<template>
  <div class="amazon-right" style="position: relative">
    <div v-if="workbench.sizeChart.isExtracting" class="loading-placeholder">
      <div class="spinner"></div>
      <p>正在使用 VLM 视觉大模型提取尺码数据，并自动换算...</p>
    </div>

    <div v-else-if="workbench.sizeChart.loading" class="loading-placeholder">
      <div class="spinner"></div>
      <p>AI 正在根据您确认的表格数据，重绘最终版英文尺码图...</p>
    </div>

    <div
      v-else-if="workbench.sizeChart.result"
      class="copy-group"
      style="
        height: 100%;
        border: none;
        background: transparent;
        padding: 0;
        display: flex;
        flex-direction: column;
      "
    >
      <div
        style="
          flex: 1;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e2e8f0;
          background: #fff;
        "
      >
        <img
          :src="workbench.sizeChart.result"
          alt="生成结果"
          style="width: 100%; height: 100%; object-fit: contain"
        />
      </div>
      <div style="display: flex; gap: 12px; margin-top: 16px">
        <button
          class="primary-btn"
          style="flex: 1; height: 44px"
          @click="downloadImage(workbench.sizeChart.result)"
        >
          下载生成的尺码图片
        </button>
        <button
          class="secondary-btn"
          style="
            padding: 0 20px;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            background: #fff;
          "
          @click="workbench.sizeChart.result = ''"
        >
          重新修改表格
        </button>
      </div>
    </div>

    <div
      v-else-if="workbench.sizeChart.tableData"
      class="copy-group"
      style="
        height: 100%;
        border: none;
        background: transparent;
        padding: 0;
        display: flex;
        flex-direction: column;
      "
    >
      <div
        style="
          background: #eff6ff;
          color: #1e3a8a;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 16px;
          font-size: 13px;
        "
      >
        ✅ 数据提取与换算成功。请修改下方表格纠正错误，确认无误后点击生成。
      </div>

      <div
        style="
          flex: 1;
          overflow-y: auto;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 20px;
        "
      >
        <h3
          style="
            margin-top: 0;
            color: #334155;
            font-size: 16px;
            margin-bottom: 16px;
          "
        >
          US Size Chart (可点击单元格修改)
        </h3>

        <table
          style="
            width: 100%;
            border-collapse: collapse;
            text-align: center;
            font-size: 14px;
          "
        >
          <thead>
            <tr>
              <th
                v-for="(col, index) in workbench.sizeChart.tableData.columns"
                :key="index"
                style="
                  border: 1px solid #cbd5e1;
                  padding: 12px;
                  background: #f1f5f9;
                  color: #334155;
                "
              >
                <input
                  v-model="workbench.sizeChart.tableData.columns[index]"
                  style="
                    width: 100%;
                    text-align: center;
                    border: none;
                    background: transparent;
                    font-weight: bold;
                    outline: none;
                  "
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rIndex) in workbench.sizeChart.tableData.data"
              :key="rIndex"
            >
              <td
                v-for="(col, cIndex) in workbench.sizeChart.tableData.columns"
                :key="cIndex"
                style="border: 1px solid #cbd5e1; padding: 10px"
              >
                <input
                  v-model="row[col]"
                  style="
                    width: 100%;
                    text-align: center;
                    border: none;
                    background: transparent;
                    outline: none;
                    color: #475569;
                  "
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="text-align: center; margin-top: 16px">
        <button
          class="primary-btn"
          style="
            width: auto;
            min-width: 300px;
            height: 44px;
            padding: 0 32px;
            border-radius: 8px;
          "
          @click="handleGenerateImage"
        >
          ✨ 数据确认无误，生成图片
        </button>
      </div>
    </div>

    <div v-else class="empty-state">
      <div style="text-align: center">
        <svg
          style="width: 48px; height: 48px; margin: 0 auto 12px; color: #cbd5e1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <p>AI 解析完成的表格将显示在这里进行校对</p>
      </div>
    </div>

    <div class="quick-converter">
      <div class="converter-header" @click="isConverterOpen = !isConverterOpen">
        <span class="title">📐 快捷单位换算</span>
        <span
          class="icon"
          style="
            font-size: 12px;
            white-space: nowrap;
            flex-shrink: 0;
            margin-right: 20px;
          "
        >
          {{ isConverterOpen ? "▼ 收起" : "▲ 展开" }}
        </span>
      </div>
      <div class="converter-body" v-show="isConverterOpen">
        <div class="calc-row">
          <input type="number" v-model="calcCm" placeholder="数值" /> cm ≈
          <strong>{{ calcCm ? (calcCm * 0.393701).toFixed(1) : "0.0" }}</strong>
          inch
        </div>
        <div class="calc-row">
          <input type="number" v-model="calcJin" placeholder="数值" /> 斤 ≈
          <strong>{{
            calcJin ? (calcJin * 1.10231).toFixed(1) : "0.0"
          }}</strong>
          lb
        </div>
        <div class="calc-row" style="margin-bottom: 0">
          <input type="number" v-model="calcKg" placeholder="数值" /> kg ≈
          <strong>{{ calcKg ? (calcKg * 2.20462).toFixed(1) : "0.0" }}</strong>
          lb
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

const workbench = useWorkbenchStore();

// 换算器状态与数据双向绑定
const isConverterOpen = ref(false); // 默认收起
const calcCm = ref(null);
const calcJin = ref(null);
const calcKg = ref(null);

// 触发图片生成逻辑
const handleGenerateImage = async () => {
  try {
    await workbench.generateSizeChartImage();
  } catch (error) {
    alert(error.message);
  }
};

// 下载图片
const downloadImage = (url) => {
  if (!url) return;
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "US_Size_Chart.png";
  anchor.click();
};
</script>

<style scoped>
/* 悬浮换算器样式 */
.quick-converter {
  position: absolute;
  top: 20px; /* 👉 这里把 bottom 改成了 top */
  right: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  width: 240px;
  z-index: 50;
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.converter-header {
  padding: 10px 14px;
  background: #f8fafc;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  border-bottom: 1px solid #e2e8f0;
  box-sizing: border-box;
}

.converter-header:hover {
  background: #f1f5f9;
}

.converter-body {
  padding: 16px 14px;
}

.calc-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 12px;
  color: #475569;
}

.calc-row input {
  width: 60px;
  padding: 4px 6px;
  margin-right: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  text-align: center;
  outline: none;
  font-size: 14px;
  transition: border-color 0.2s;
}

.calc-row input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* 隐藏 input type="number" 自带的上下小箭头 */
.calc-row input::-webkit-outer-spin-button,
.calc-row input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.calc-row strong {
  margin: 0 6px;
  color: #2563eb;
  font-size: 15px;
  min-width: 40px;
  display: inline-block;
}
</style>
